<template>
    <div class="con">
        <Calendar :textTop="textTop" sundayStart v-on:choseDay="clickDay" v-on:changeMonth="changeDate"
            :markDate="scheduleList" @choseDay="clickToday" @changeMonth="changeMonth" ref="calendarRef">
        </Calendar>
    </div>
</template>

<script>
import Calendar from 'vue-calendar-component';

export default {
    data() {
        return {
            textTop: ['日', '一', '二', '三', '四', '五', '六'],
            arr_week: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
            dateObj: {}
        };
    },
    props: {
        scheduleList: {
            default: []
        }
    },
    components: {
        Calendar
    },
    created() {
        this.dateObj.date = new Date().toLocaleDateString()
        this.$nextTick(() => {
            this.getisSameMonth(new Date().toLocaleDateString())
        })
        this.getdateText()
        this.getWeek()
    },
    mounted() {

    },
    methods: {
        changeMonth(date) {
            // console.log(date, 'dsad');
            // this.dateObj.date = date
            // this.getWeek(date)
            // this.getdateText(date)
            // this.$emit('clickDay', this.dateObj,)
            // // document.querySelectorAll('.wh_isToday').forEach(el => {
            // //     el.classList.remove('wh_isToday');
            // // });
            // this.getisSameMonth(date)

        },
        getisSameMonth(date) {
            const date1 = new Date(date)
            const date2 = new Date(new Date().toLocaleDateString())
            const year1 = date1.getFullYear()
            const month1 = date1.getMonth() // 注意：0-11表示1-12月
            const year2 = date2.getFullYear()
            const month2 = date2.getMonth()
            const isSameMonth = year1 === year2 && month1 === month2
            // this.$nextTick(() => {
            //     console.log(isSameMonth);
                
            //     if (isSameMonth) {
            //         document.querySelector('.wh_isToday').textContent = '今'
            //     }else{
            //         document.querySelector('.wh_isToday').textContent = '2'

            //     }
            // })
        },
        getWeek(date) {
            let now = date ? new Date(date) : new Date();
            this.dateObj.week = this.arr_week[now.getDay()]
        },
        getdateText(date) {
            let arr = date ? date.split('/') : new Date().toLocaleDateString().split('/')
            let dateText = arr[0] + '年' + arr[1] + '月' + arr[2] + '日'
            this.dateObj.dateText = dateText
        },
        clickDay(date) {
            this.dateObj.date = date
            this.getWeek(date)
            this.getdateText(date)
            this.$emit('clickDay', this.dateObj,)
        },
        changeDate(date) {
            console.log(date, '左右点击切换月份'); //左右点击切换月份
        },
        clickToday(date) {
            console.log(date, '跳到了本月'); // 跳到了本月
        }
    }
}
</script>

<style lang="less" scoped>
.con {
    /deep/.wh_content_all {
        background: transparent !important;
        box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);

        .wh_top_changge {
            .wh_content_li {
                color: #000;
            }
        }

        .wh_jiantou1 {
            border-top: 2px solid #909399;
            border-left: 2px solid #909399;
            width: 7px;
            height: 7px;
        }

        .wh_jiantou2 {
            border-top: 2px solid #909399;
            border-right: 2px solid #909399;
            width: 7px;
            height: 7px;
        }

        .wh_isMark {
            background: #fff;
            position: relative;
            width: 38px;
        }

        .wh_isMark::after {
            content: '';
            left: 0;
            display: block;
            width: 8px;
            /* 黑点宽度 */
            height: 8px;
            /* 黑点高度 */
            background-color: green;
            /* 设置颜色为黑色 */
            border-radius: 50%;
            /* 圆形效果 */
            position: absolute;
            bottom: 0px;
            /* 调整位置使其位于元素底部 */
            left: 50%;
            transform: translateX(-50%);
        }

        .wh_item_date {
            width: 38px;
            height: 38px;
            line-height: 38px;
        }

        .wh_item_date:hover {
            background: #fff !important;
            border-radius: 10px !important;
            outline: 1px solid #409eff ;
        }

        .wh_content_item .wh_isToday {
            background: #409eff  !important;
            border-radius: 10px !important;
            color: #fff;
            background-image: url('~@/assets/imgs/bianji@3x.svg') !important;
            background-size: cover;
            position: relative;
            z-index: 99;
        }

        .wh_content_item .wh_chose_day {
            background: #fff !important;
            color: #333 !important;
            outline: 1px solid #409eff ;
            border-radius: 10px !important;
        }

        .wh_content_item {
            color: #000;
            height: 50px;
        }
    }
}
</style>